"use client";

import { usePathname } from "@/i18n/navigation";
import { Suspense, useEffect } from "react";

function RouteChangecontent() {
  const pathname = usePathname();

  useEffect(() => {
    const savedUsage = localStorage.getItem("redeemSim");

    if (savedUsage) {
      if (!pathname.includes("/redeem")) {
        localStorage.removeItem("redeemSim");
      }
    } else {
      return;
    }
  }, [pathname]);
  return <></>;
}

export function RouteChangeListener() {
  return (
    <Suspense fallback={null}>
      <RouteChangecontent />
    </Suspense>
  );
}
